<template>
  <div>

    <v-row v-if="getSubscriptionName === null">
      <v-col>
        <v-card elevation=0>
          <v-card-text class="text-center">
            <v-progress-circular
              :size="80"
              :width="7"
              color="primary"
              indeterminate
              :aria-label="$t('common.loading')"
            ></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <div v-if="getSubscriptionName !== null">
      <SubscriptionPlansIndex v-if="getSubscriptionName === 'trial'">
      </SubscriptionPlansIndex>

      <PaidSubscriptionsPage v-if="getSubscriptionName !== 'trial'">
      </PaidSubscriptionsPage>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useCommonStore } from '@/stores/CommonStore.js'
import { useSystemStore } from '@/stores/SystemStore.js'
import { useTenantStore } from '@/stores/TenantStore.js'
import PaidSubscriptionsPage from './components/PaidSubscriptionsPage.vue'
import SubscriptionPlansIndex from './SubscriptionPlansIndex.vue'

export default {
  name: "SubscriptionsIndex",
  components: {
    PaidSubscriptionsPage,
    SubscriptionPlansIndex,
  },
  watch: {
    subscriptionType(newType) {
      if (this.isRecurringSubscription(newType)) {
        this.$router.push('/console/index');
      }
    }
  },
  afterCreate() {
    if (!this.$canControlTenantConfig()) {
      this.$router.push('/console/index');
    }


    if (this.isRecurringSubscription(this.subscriptionType)) {
      this.$router.push('/console/index');
    }
  },
  async mounted() {
    // If the user object is not available, fetch it from the database
    if (!this.user) {
      try {
        const authStore = useAuthStore();
        await authStore.refreshDBUser();

        if (this.isRootUser || !this.$canControlTenantConfig()) {
          this.$router.push('/console/index');
        }



        if (this.isRecurringSubscription(this.subscriptionType)) {
          this.$router.push('/console/index');
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          const localizedMessage = this.$localizeMessage(error.response.data.error, this.$t('backend.system-error'));
          this.$showMessage(localizedMessage, { type: 'error' });
        } else {
          console.log(error);
          this.$showMessage(this.$t('backend.system-error'), { type: 'error' });
        }
      }
    }
  },
  methods: {
    isRecurringSubscription(type) {
      const tenantStore = useTenantStore();
      return tenantStore.getRecurringSubscriptionTypes.includes(type);
    },
  },
  computed: {
    user: function() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    getSubscriptionName() {
      const systemStore = useSystemStore();
      const subscription = systemStore.getSubscription;

      return subscription?.subscription?.name || null;
    },
    isRootUser() {
      const commonStore = useCommonStore();
      const rootFolderId = commonStore.rootFolderId;

      const authStore = useAuthStore();
      const rootNodeId = authStore.rootNodeId;

      return rootNodeId === rootFolderId;
    },
    subscriptionType: function() {
      const authStore = useAuthStore();
      const activeTenant = authStore.getActiveTenant;

      return activeTenant?.subscription?.subscriptionType || null;
    },
  },
}
</script>

<style>
</style>
